import { observer } from 'mobx-react-lite';
import { FC, useEffect, useState } from 'react';
import { useStore } from '../../../hooks/useStore';
import { Loading } from '../../../lib/components';
import { CardWidget } from '../../../lib/components/compound/surfaces/cardWidget';
import Util from '../../../misc/util';
import { EmployeeDashboardListItem } from '../shared/employeeListItem';
import { ScrollableList } from '../shared/scrollableList';
import { EmployeeListItem } from '@pxtra-client-lib-legacy/gen';
import { useTranslation } from 'react-i18next';

export const AnniversariesDashboardWidget: FC = observer(() => {
  const { employeeStore, companyStore } = useStore();
  const [sortedAnniversaryEmployees, setSortedAnniversaryEmployees] =
    useState<EmployeeListItem[]>();
  const { t } = useTranslation();

  const getSortedAnniversaryEmployees = async () => {
    const employees = await employeeStore.fetchList([
      'entry_date',
      'first_name',
      'id',
      'last_name',
      'position_name',
      'profile_picture',
      'status'
    ]);
    setSortedAnniversaryEmployees(
      employees
        ?.filter(
          (e) =>
            e.entry_date &&
            e.status !== 'RESIGNED' &&
            e.status !== 'INACTIVE' &&
            e.status !== 'DEACTIVATION_DELAYED'
        )
        .sort((prev, curr) => {
          const prevDate =
            (prev?.entry_date && Util.calcNextYearlyDateMilliseconds(prev.entry_date)) || 0;
          const currDate =
            (curr?.entry_date && Util.calcNextYearlyDateMilliseconds(curr.entry_date)) || 0;

          return currDate && prevDate && prevDate - currDate;
        })
        .slice(0, 5)
    );
  };

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!companyStore.company) return;

    const abortController = new AbortController();
    const fetch = async () => {
      try {
        setIsLoading(true);
        await getSortedAnniversaryEmployees();
        setIsLoading(false);
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
        }
      }
    };

    fetch();
    return () => abortController.abort();
  }, [companyStore.company]);

  return (
    <CardWidget title={t('common:ANNIVERSARY_other')} subTitle={t('common:ANNIVERSARY_SUBTITLE')}>
      {isLoading ? (
        <Loading />
      ) : (
        <ScrollableList>
          {sortedAnniversaryEmployees &&
            sortedAnniversaryEmployees.map((employee, index) => {
              return (
                <EmployeeDashboardListItem
                  id={employee.id}
                  key={index}
                  first_name={employee.first_name}
                  last_name={employee.last_name}
                  profile_picture={employee.profile_picture}
                  entry_date={employee.entry_date}
                  position_name={employee.position_name}
                />
              );
            })}
        </ScrollableList>
      )}
    </CardWidget>
  );
});
